import React, { useEffect, useState } from 'react'
import "./GGDialogueBox.scss"
import "./GGDialogueModalWindow.scss"
import {  Modal } from '@mui/material';
import ModalActionBtn, { ModalBtnType } from '../../CommonComponents/ModalButtons/ModalActionBtn/ModalActionBtn'
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorIcon from '@mui/icons-material/Error';
import DangerousIcon from '@mui/icons-material/Dangerous';
import ModalCloseBtn from '../../CommonComponents/ModalButtons/ModalCloseBtn/ModalCloseBtn';

export enum dialogueType {
  Alert,
  Info,
  Error,
  None
}

interface GGDialogueBoxProps {
  type: dialogueType
  isOpen: boolean
  message: string
  closeHandler: Function
  successHandler: Function
}

// == Dialogue Modal Window == //

interface GGDialogueModalWindowPropsInterface {
  childView: JSX.Element;
  open: boolean;
  onCloseHandler: () => void;
  title: string;
  isDialogueBox: boolean;
  dialogueBoxType: dialogueType;
}

const GGDialogueModalWindow = ({childView, open, onCloseHandler, title, isDialogueBox, dialogueBoxType}: GGDialogueModalWindowPropsInterface) => {

  const [scrollPosition, setScrollPosition] = useState(0);
  
  const onClose = (_event: any, reason: any) => {
      if(reason && reason === 'backdropClick') {
          return
      }

      onCloseHandler()
  }
  
  const disableScroll = () => {
      const currentPosition = window.scrollY;
      setScrollPosition(currentPosition);
      document.body.style.position = "fixed";
      document.body.style.top = `-${currentPosition}px`;
    };

  // Function to enable background scrolling
  const enableScroll = () => {
      document.body.style.position = "static";
      window.scrollTo(0, scrollPosition);
  };

  const setDialogueIcon = () => {
      switch(dialogueBoxType) {
          case dialogueType.Alert:
              return <ReportProblemIcon style={{ color: "#F45800", fontSize: "2.5rem" }} />
          case dialogueType.Info:
              return <ErrorIcon style={{ color: "#0195D6", fontSize: "2.5rem" }} />
          case dialogueType.Error:
              return <DangerousIcon style={{ color: "#DE412E", fontSize: "2.5rem" }} />
          default:
              return <></>
      }
  }
  
  useEffect(() => {
      if(open) disableScroll()
      else enableScroll()
      
      return () => enableScroll();
  // eslint-disable-next-line
  }, [open])

return (
  <Modal         
      open={open}
      onClose={onClose}
      disableEscapeKeyDown
      className={isDialogueBox ? 'modal-dialogue-overlay dialogue' : 'modal-dialogue-overlay'}
     >
          <div className={isDialogueBox ? "modal-container dialogue" : "modal-container"}>
              <div className="modal-header">
                  <h3>{title}</h3>
                  { !isDialogueBox ? 
                      <ModalCloseBtn handleCancel={onCloseHandler} /> :
                      <div className='dialogueBoxIcon'>{setDialogueIcon()}</div>
                  }
              </div>

          <div className="modal-content">{childView}</div>
      </div>
  </Modal>
)
}

const GGDialogueBox = (props: GGDialogueBoxProps) => {

  const { type, isOpen, message, closeHandler, successHandler } = props

  // Alert
  const alert = () => (
    <div>
      <p style={{margin: "0 0 1.5rem 0", fontSize: "1rem"}}>{message}</p>
      <div style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
        <ModalActionBtn type={ModalBtnType.light} text='Ok' callToAction={successHandler} />
        <span style={{width: "1rem"}}></span>
        <ModalActionBtn type={ModalBtnType.dark} text='Cancel' callToAction={closeHandler} />
      </div>
    </div>
  )

  // Info
  const info = () => (
    <div>
      <p style={{margin: "0 0 1.5rem 0", fontSize: "1rem"}}>{message}</p>
      <div style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
        <ModalActionBtn type={ModalBtnType.light} text='Ok' callToAction={successHandler} />
        <span style={{width: "1rem"}}></span>
        <ModalActionBtn type={ModalBtnType.dark} text='Cancel' callToAction={closeHandler} />
      </div>
    </div>
  )

  // Error
  const error = () => (
    <div>
      <p style={{margin: "0 0 1.5rem 0", fontSize: "1rem"}}>{message}</p>
      <div style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}><ModalActionBtn type={ModalBtnType.dark} text='Close' callToAction={closeHandler} /></div>
    </div>
  )

  const setChild = () => {
    switch (type) {
      case dialogueType.Alert:
        return alert()
      case dialogueType.Info:
        return info()
      case dialogueType.Error:
        return error()
      default:
        return <></>
    }
  }

  const setTitle = () => {
    switch (type) {
      case dialogueType.Alert:
      case dialogueType.Info:
        return "Are You Sure?"
      case dialogueType.Error:
        return "Error!"
      default:
        return ""
    }
  }

  return (
    <GGDialogueModalWindow childView={setChild()} open={isOpen} onCloseHandler={() => closeHandler} title={setTitle()} isDialogueBox={true} dialogueBoxType={type} />
  )
}

export default GGDialogueBox